import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getCurrentEnvironment } from '@/helpers';
import { APP_ENVIRONMENT } from '@/constants';
import { Tooltip } from '@/components';
import LeftArrowIcon from '@/icons/icon_left_arrow.svg';
import RightArrowIcon from '@/icons/icon_right_arrow.svg';

import {
  IconWrapper,
  Icon,
  NavInfo,
  NavInfoWrap,
  LeftFloatingButton,
  RightFloatingButton,
  RightArrowButtonWrapperStyled,
  LeftArrowButtonWrapperStyled,
  NavInfoWrapperStyled,
  NavInfoStyled,
  NavInfoGoToPageStyled,
  NavInfoGoToPageLabelStyled,
  NavInfoGoToPageInputStyled,
} from './styles';

const currentEnvironment = getCurrentEnvironment();

const NavButtons = props => {
  const { paginationPageNum, paginationPagesTotal, paginationPageSize, paginationItemsTotal, paginationToPrevPage, paginationToNextPage, paginationGoToPage } = props;
  const [isShowingPageModal, showPageModal] = useState(false);
  const [tempPage, setTempPage] = useState(paginationPageNum);

  const onInputChangeClb = (value) => {
    const parsedQty = Number.parseInt(value)
    if (Number.isNaN(parsedQty)) {
      setTempPage('');
    } else if (parsedQty > paginationPagesTotal) {
      setTempPage(paginationPagesTotal);
    } else {
      setTempPage(parsedQty);
    }
  }

  const handleClose = () => {
    paginationGoToPage(tempPage);
    showPageModal(false);
  }

  let currPageLabel = paginationPageNum;
  if (paginationPageSize > 1) {
    // show range
    const rangeFirstItemNum = (paginationPageNum - 1) * paginationPageSize + 1;
    let rangeLastItemNum = rangeFirstItemNum + paginationPageSize - 1;
    if (rangeLastItemNum > paginationItemsTotal) {
      rangeLastItemNum = paginationItemsTotal;
    }
    currPageLabel = rangeFirstItemNum === rangeLastItemNum ? rangeFirstItemNum : rangeFirstItemNum + ' - ' + rangeLastItemNum;
  }

  const isLeftArrowShown = paginationPageNum > 1;
  const isRightArrowShown = paginationPageNum < paginationPagesTotal;

  switch (currentEnvironment) {
    case APP_ENVIRONMENT.WEB_COMPONENT: {
      return (
        <>
          {isLeftArrowShown && (
            <LeftArrowButtonWrapperStyled onClick={paginationToPrevPage}>
              <IconWrapper>
                <img src={LeftArrowIcon} />
              </IconWrapper>
            </LeftArrowButtonWrapperStyled>
          )}

          <Tooltip className='Select inputContainer' placement="top" open={isShowingPageModal} handleClose={() => handleClose()} title=
            {
              <NavInfoGoToPageStyled>
                <NavInfoGoToPageLabelStyled>
                  <FormattedMessage
                    id="app.editor.modal.goToPageModal.title"
                    defaultMessage="Go to page"
                  />:
                </NavInfoGoToPageLabelStyled>
                <NavInfoGoToPageInputStyled
                  value={tempPage}
                  type='number'
                  onKeyUp={(e) => e.code === 'Enter'? handleClose() : null}
                  min={0}
                  max={paginationPagesTotal + 1}
                  onChange={(e) => onInputChangeClb(e.target.value)}
                />
              </NavInfoGoToPageStyled>
            }
          >
            <NavInfoWrapperStyled $clickable={paginationPagesTotal > 1} onClick={() => paginationPagesTotal > 1 ?
              showPageModal(true) : null}>
              <NavInfoStyled>
                {currPageLabel} / {paginationItemsTotal}
              </NavInfoStyled>
            </NavInfoWrapperStyled>
          </Tooltip>

          {isRightArrowShown && (
            <RightArrowButtonWrapperStyled onClick={paginationToNextPage}>
              <IconWrapper>
                <img src={RightArrowIcon} />
              </IconWrapper>
            </RightArrowButtonWrapperStyled>
          )}
        </>
      );
    }
    default: {
      return null;
    }
  }
};

export default React.memo(NavButtons);
